import { CHANGE_ENABLE_LAYER, CHANGE_DISABLE_LAYER, RESET_LAYER } from "./type";

export const changeMapLayer = (status) => async (dispatch) => {
  dispatch({
    type: CHANGE_ENABLE_LAYER,
    payload: status,
  });
};

export const resetMapLayer = () => async (dispatch) => {
  dispatch({
    type: RESET_LAYER,
  });
};

export const disableMapLayer = (status) => async (dispatch) => {
  dispatch({
    type: CHANGE_DISABLE_LAYER,
    payload: status,
  });
};
